const utils = require('frontend-controller/lib/utils')

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'scheduler',
        'scheduler',
    ],

    config: {
        projectsControllerComponentClass: 'templates_customers_projects_controller',
        projectTermsControllerComponentClass: 'templates_customers_projectTerms_controller',
        // showNav: {
        //     periodSelection: false,
        //     periodSelectionSlim: true,
        // },
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_status': true,
            'resourceChanged.bo_projects': true,
            'resourceChanged.bo_customers': false,
            'resourceChanged.bo_employees': false,
            'resourceChanged.bo_projectTerms': true,
            'resourceChanged.bo_projectTermJobs': false,
            'resourceChanged.bo_customerContacts': false,
            'resourceChanged.bo_projectTermJobStatus': false,
        },
    },

    model: {
        // datePickerData: {
        //     config: {
        //         inputSize: 14
        //     }
        // }
    },

    methods: {
        loadResourcesGranted(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
            if(actionKey === 'refreshResources'){
                return utils.collectionSize((resourceFilters || {}).filters) > 0
            }

            return true
        },

        sanitizeResources(){
            this.model.taskData = []

            // let statusSymbol
            utils.forEach(this.resourceData.data || [], (element, key) => {
                const attributes = element.attributes || {}
                // statusSymbol = '<i class="statusSymbol fi fi-check"></i>'
                const type = attributes.type
                const classes = [type]
                if(attributes.status){
                    classes.push(`status_${attributes.status}`)
                }
                if(attributes.statusOutDated){
                    classes.push(`statusOutDated`)
                }
                // if(type === 'vacation'){
                //     statusSymbol = '<i class="statusSymbol fi fi-exclamation-triangle"></i>'
                // }

                const titleParts = []
                if(attributes.startTS){
                    titleParts.push(utils.moment(attributes.startTS).format('HH:mm'))
                }
                if(attributes.title){
                    titleParts.push(attributes.title)
                }
                const title = titleParts.join(' | ') || ''

                this.model.taskData.push({
                    title: `<div class="term">${title}</div>`,
                    alt: attributes.title,
                    date: attributes.startTS,
                    class: classes.join(' '),
                    dataType: type,
                    dataID: key,
                    showTime: false,
                    attributes,
                })
            })
        },
    },

    handlers: [
        {
            name: 'heartbeat.reconnect',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
    ],
}